/**
 * @generated SignedSource<<ee9fe3ecb9fd573defa83c2df1cefa49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreProductExpireBatchStatus = "ACTIVE" | "INACTIVE";
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchStatusFooter_productExpireBatch$data = {
  readonly deadlineAtDate: {
    readonly isoString: string;
  };
  readonly id: string;
  readonly product: {
    readonly id: string;
  };
  readonly status: StoreProductExpireBatchStatus;
  readonly " $fragmentType": "ProductExpireBatchStatusFooter_productExpireBatch";
};
export type ProductExpireBatchStatusFooter_productExpireBatch$key = {
  readonly " $data"?: ProductExpireBatchStatusFooter_productExpireBatch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchStatusFooter_productExpireBatch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatchStatusFooter_productExpireBatch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "StoreProduct",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "deadlineAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProductExpireBatch",
  "abstractKey": null
};
})();

(node as any).hash = "98686b29396f4478b4f6444917e825ec";

export default node;
